import * as user from 'packages/common/services/user';
import caWebsocketClient from '@contaazul/ca-websocket-client';
import { getAuthToken } from 'packages/common/helpers/auth';
import {
  WEBSOCKET_BASE_URL, WEBSOCKET_PATH, WEBSOCKET_NAMESPACE, WEBSOCKET_EVENTS,
} from './constants';

function connect() {
  if (window.caWebsocketConnection) {
    return window.caWebsocketConnection.getSocket();
  }

  return caWebsocketClient.connect({
    host: WEBSOCKET_BASE_URL,
    path: WEBSOCKET_PATH,
    namespace: WEBSOCKET_NAMESPACE,
    credentials: {
      authorization: getAuthToken(),
      userId: user.getUserId(),
      tenantId: user.getTenantId(),
    },
  });
}

export function on({ event, listener }) {
  const socket = connect();

  return socket.on(event, listener);
}

export function off({ event, listener }) {
  const socket = connect();

  return socket.off(event, listener);
}

export function getWebsocketEvents() {
  return WEBSOCKET_EVENTS;
}
